import PropTypes from 'prop-types'
import React from 'react'

const SpaceBtn = (props) => {
  /*64x28*/
  return (
    <span className="space-btn-svg-wrapper">
      <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 64 18"
        style={{
          fill: props.fill,
        }}
      >
        <title>Space</title>
        <g fillRule="evenodd" strokeLinecap="square" strokeWidth="7">
          <path
            strokeOpacity={props.strokeOpacity}
            fill={props.fill}
            stroke={props.fill}
            d="M4 12.75V4.191M60 12.75V4.191M4.368 14h55.44"
          />
        </g>
      </svg>
    </span>
  )
}

SpaceBtn.propTypes = {
  fill: PropTypes.string,
  strokeOpacity: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export default SpaceBtn
